
    import { layoutVariationMap } from "../common/layyoutVariationMap";

    export function wrapComponentsInLayout(components: any[],variationConfig:any): any[] | any {

  //    const layoutType = variationConfig.layoutType;
  // const variation = variationConfig.variation;
  // const cardWrapping = variationConfig.cardWrapping;
  const includePreview = false;
  const groupByTag = (list: any[]) => {
    const map = new Map<string, any[]>();
    list.forEach((component) => {
      const tag = component.tag || "Other";
      if (!map.has(tag)) map.set(tag, []);
      map.get(tag)!.push(component);
    });
    return map;
  };

  const getColumnConfig = (count: number, span: number): any[] =>
    Array.from({ length: count }, () => ({
      type: "fgcol",
      id: crypto.randomUUID(),
      span: span.toString(),
      icon: "fa fa-columns",
      config: false,
      name: `${span} Columns`,
      logo: "fgcol",
      children: [],
      uuid: crypto.randomUUID(),
    }));

const buildRow = (items: any[]): any => {
  const fullWidthTypes = ["fgAttachmentConfiguration", "fgDynamicDataTable"];

  // Separate full-width and regular components
  const fullWidthItems = items.filter((item) => fullWidthTypes.includes(item.type));
  const regularItems = items.filter((item) => !fullWidthTypes.includes(item.type));

  // Determine number of columns for regular items
  let columnCount = 1;
  if (variationConfig.layoutType === "AUTO") {
    columnCount = regularItems.length > 10 ? 2 : 1;
  } else if (variationConfig.layoutType === "2COL") {
    columnCount = 2;
  } else if (variationConfig.layoutType === "3COL") {
    columnCount = 3;
  } else if (variationConfig.layoutType === "4COL") {
    columnCount = 4;
  }

  const span = Math.floor(12 / columnCount);
  const columns = getColumnConfig(columnCount, span);
  const chunkSize = Math.ceil(regularItems.length / columnCount);

  for (let i = 0; i < columnCount; i++) {
    columns[i].children = regularItems.slice(i * chunkSize, (i + 1) * chunkSize);
  }

  // Add full-width items as individual fgcol elements
  const fullWidthCols = fullWidthItems.map((comp) => ({
    type: "fgcol",
    id: crypto.randomUUID(),
    span: "12",
    icon: "fa fa-columns",
    config: false,
    name: "Full Width",
    logo: "fgcol",
    children: [comp],
    uuid: crypto.randomUUID(),
  }));

  // Combine all columns into one fgrow
  const allColumns = [...columns, ...fullWidthCols];

  return {
    type: "fgrow",
    id: crypto.randomUUID(),
    name: "Row",
    icon: "fa fa-bars",
    config: false,
    logo: "fgrow",
    condition: {},
    isCoreConfig: true,
    category: "GRIDS",
    uuid: crypto.randomUUID(),
    children: allColumns,
  };
};



  const buildCard = (tag: string, children: any[]): any => ({
    type: "fgcardContainer",
    name: "Card Container",
    icon: "fa fa-columns",
    config: true,
    condition: {},
    isCoreConfig: true,
    category: "LAYOUT",
    disableAdd: true,
    uuid: crypto.randomUUID(),
    class: "card",
    styles: {},
    children: [
      {
        type: "fgCardHeader",
        name: "Card Header",
        icon: "fa fa-square-o",
        config: true,
        class: "card-header",
        condition: {},
        isCoreConfig: true,
        category: "LAYOUT",
        isHiddenInCategory: true,
        uuid: crypto.randomUUID(),
        children: [
          {
            type: "fgword",
            subtype: "h4",
            cat: "HEADING",
            icon: "fa fa-square-o",
            name: "Heading 4",
            text: tag,
            condition: {},
            isCoreConfig: true,
            category: "STATIC",
            uuid: crypto.randomUUID(),
            textAlign: "text-left",
            styles: {},
          },
        ],
      },
      {
        type: "fgCardBody",
        name: "Card Body",
        icon: "fa fa-square-o",
        config: true,
        class: "card-body",
        condition: {},
        isCoreConfig: true,
        category: "GENERAL",
        isHiddenInCategory: true,
        uuid: crypto.randomUUID(),
        children: children,
      },
    ],
  });

  const grouped = groupByTag(components);

  // === Variation Handling ===
  if (variationConfig.variation === "simple") {
    // Return list of fgrow (unwrapped)
    const simpleReturn = Array.from(grouped.entries()).map(([_, items]) => buildRow(items));
    //console.log("Simple Return : " + simpleReturn)
     //console.log(simpleReturn);
   // return Array.from(grouped.entries()).map(([_, items]) => buildRow(items));
   return simpleReturn;
  }
  //  if (variation === 'simple-group') {
  //   // Return list of wrapped cardContainers
  //   return Array.from(grouped.entries()).map(([tag, items]) => buildCard(tag, [buildRow(items)]));
  // }

  if (variationConfig.variation === "card-simple") {
    // Return list of wrapped cardContainers
    return Array.from(grouped.entries()).map(([tag, items]) =>
      buildCard(tag, [buildRow(items)])
    );
  }

  if (variationConfig.variation === "tabs") {
    return {
      type: "fgtabs",
      name: "Tab Container",
      icon: "fa fa-folder",
      config: true,
      uuid: crypto.randomUUID(),
      isVertical:variationConfig.ui.orientation == 'horizontal' ? false : true,
      children: Array.from(grouped.entries()).map(([tag, items]) => ({
        type: "fgtabs",
        subType: "fgTabItem",
        name: tag,
        label: tag,
        uuid: crypto.randomUUID(),
        children: variationConfig.cardWrapping
          ? [buildCard(tag, [buildRow(items)])]
          : [buildRow(items)],
      })),
    };
  }

  if (variationConfig.variation === "stepper") {
    const stepItems = Array.from(grouped.entries()).map(([tag, items]) => {
      const innerContent = variationConfig.cardWrapping
        ? [buildCard(tag, [buildRow(items)])]
        : [buildRow(items)];

      return {
        type: "fgStepper",
        name: tag,
        icon: "fa fa-columns",
        config: true,
        options: { stepperType: variationConfig.ui.direction },
        condition: {},
        isCoreConfig: true,
        category: "LAYOUT",
        uuid: crypto.randomUUID(),
        stepperColumnSpan:2,   
        stepContentColumnSpan:10, 
        isColumnSpanEnabled:true,


        children: [
          {
            type: "fgcustomcontainer",
            name: "Custom Container",
            icon: "fa fa-square-o",
            class: "card-default",
            header: true,
            heading: tag,
            config: true,
            condition: {},
            isCoreConfig: true,
            category: "LAYOUT",
            uuid: crypto.randomUUID(),
            children: innerContent,
          },
        ],
      };
    });

    // ✅ Conditionally add Preview step
    if (includePreview) {
      const allComponents = Array.from(grouped.values()).reduce(
        (acc, val) => acc.concat(val),
        []
      );
      const previewInnerContent = variationConfig.cardWrapping
        ? [buildCard("Preview", [buildRow(allComponents)])]
        : [buildRow(allComponents)];

      const previewStep = {
        type: "fgStepper",
        name: "Preview",
        icon: "fa fa-columns",
        config: true,
        options: { stepperType: variationConfig.ui.direction },
        condition: {},
        isCoreConfig: true,
        category: "LAYOUT",
        uuid: crypto.randomUUID(),
         stepperColumnSpan:2,   
        stepContentColumnSpan:10, 
        isColumnSpanEnabled:true,
        children: [
          {
            type: "fgcustomcontainer",
            name: "Preview Container",
            icon: "fa fa-square-o",
            class: "card-default",
            header: true,
            heading: "Preview",
            config: true,
            condition: {},
            isCoreConfig: true,
            category: "LAYOUT",
            uuid: crypto.randomUUID(),
            children: previewInnerContent,
          },
        ],
      };

      stepItems.push(previewStep);
    }

    return {
      type: "fgStepper",
      name: "Stepper",
      icon: "fa fa-columns",
      config: true,
      options: { stepperType: variationConfig.ui.direction },
      condition: {},
      isCoreConfig: true,
      category: "LAYOUT",
      uuid: crypto.randomUUID(),
      stepperColumnSpan:2,   
        stepContentColumnSpan:10, 
        isColumnSpanEnabled:true,
      showPrevNext: true,
      stepValidation: false,
      children: stepItems,
    };
  }

  // fallback
  return [];
}
